(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-announce]');
    if (!bar) return;
    var msgs = bar.querySelectorAll('[data-announce-msg]');
    if (msgs.length < 2) return;
    var i = 0, paused = false;
    var every = (parseInt(bar.getAttribute('data-interval'), 10) || 8) * 1000;
    function show(n) {
      msgs.forEach(function (m, k) {
        var on = k === n;
        m.classList.toggle('is-on', on);
        m.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      // out, then in: the two never sit on top of each other
      msgs[i].classList.remove('is-on');
      setTimeout(function () { i = (i + 1) % msgs.length; show(i); }, 420);
    }, every);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    function root() { return document.getElementById('cart-drawer'); }
    function shipDates() {
      var d = root(), ship = d && d.querySelector('[data-ship]');
      if (!ship) return;
      var nums = (ship.getAttribute('data-ship') || '').match(/\d+/g);
      if (!nums || !nums.length) return;
      function addBiz(days) {
        var t = new Date(); t.setHours(12, 0, 0, 0);
        while (days > 0) { t.setDate(t.getDate() + 1); if (t.getDay() !== 0 && t.getDay() !== 6) days--; }
        return t;
      }
      var a = addBiz(parseInt(nums[0], 10)), b = addBiz(parseInt(nums[nums.length - 1], 10)), f = { month: 'short', day: 'numeric' };
      var to = a.getMonth() === b.getMonth() ? b.toLocaleDateString(undefined, { day: 'numeric' }) : b.toLocaleDateString(undefined, f);
      ship.textContent = 'ships ' + a.toLocaleDateString(undefined, f) + '\u2013' + to;
    }
    function render(sections, cart) {
      var d = root();
      if (!d || !sections || !sections['cart-drawer']) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = sections['cart-drawer'];
      var fresh = tmp.querySelector('#cart-drawer');
      if (fresh) d.innerHTML = fresh.innerHTML;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }
    shipDates();
    // the product page swaps the drawer in itself, then announces it: the dates follow
    document.addEventListener('cart:updated', shipDates);
    function post(path, body) {
      return fetch(window.Shopify.routes.root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(Object.assign({ sections: 'cart-drawer' }, body))
      }).then(function (r) { return r.json(); });
    }
    // from the element, because this block is compiled to a static file and Liquid never runs here
    function maxPerLine() {
      var d = root();
      return Number(d && d.getAttribute('data-max-per-line')) || 25;
    }
    function capped(li, want) {
      var q = Math.max(0, Math.min(maxPerLine(), Math.floor(Number(want) || 0)));
      var note = li.querySelector('[data-cap]');
      if (note) note.hidden = Number(want) <= maxPerLine();
      return q;
    }
    function changeLine(li, qty) {
      li.classList.add('is-busy');
      post('cart/change.js', { line: Number(li.getAttribute('data-line')), quantity: qty })
        .then(function (data) { render(data.sections, data); })
        .catch(function () { li.classList.remove('is-busy'); });
    }
    document.addEventListener('click', function (e) {
      var d = root(); if (!d || !d.contains(e.target)) return;
      var step = e.target.closest('[data-step]');
      if (step) {
        var li = step.closest('.cartd__item');
        var input = li.querySelector('[data-qty-input]');
        changeLine(li, capped(li, Number(input.value) + Number(step.getAttribute('data-step'))));
      }
      var rm = e.target.closest('[data-remove]');
      if (rm) changeLine(rm.closest('.cartd__item'), 0);
      // a little extra: colour dot or size chip picks the variant
      var chip = e.target.closest('[data-x-colour], [data-x-size]');
      if (chip) {
        var pick = chip.closest('[data-extra-pick]');
        var group = chip.hasAttribute('data-x-colour') ? '[data-x-colour]' : '[data-x-size]';
        pick.querySelectorAll(group).forEach(function (b) { b.classList.toggle('is-on', b === chip); b.setAttribute('aria-pressed', b === chip ? 'true' : 'false'); });
        var c = pick.querySelector('[data-x-colour].is-on'), sz = pick.querySelector('[data-x-size].is-on');
        var variants = JSON.parse(pick.getAttribute('data-variants') || '[]');
        var colour = c ? c.getAttribute('data-x-colour') : (variants[0] ? variants[0].c : null);
        // sizes that don't come in this colour go faint
        pick.querySelectorAll('[data-x-size]').forEach(function (b) {
          var ok = variants.some(function (v) { return v.c === colour && v.s === b.getAttribute('data-x-size'); });
          b.classList.toggle('is-out', !ok);
        });
        var hit = sz && variants.find(function (v) { return v.c === colour && v.s === sz.getAttribute('data-x-size'); });
        pick.setAttribute('data-variant', hit ? hit.id : 0);
        pick.querySelector('[data-extra-add]').disabled = !hit;
        return;
      }
      // a little extra: add the chosen piece, then the whole drawer redraws (new suggestions too)
      var xa = e.target.closest('[data-extra-add]');
      if (xa) {
        var row = xa.closest('.cartd__x'), pick2 = row.querySelector('[data-extra-pick]');
        var vid = pick2 ? Number(pick2.getAttribute('data-variant')) : 0;
        if (!vid) return;
        row.classList.add('is-busy');
        post('cart/add.js', { items: [{ id: vid, quantity: 1 }] })
          .then(function (data) {
            return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) { render(data.sections, cart); });
          })
          .catch(function () { row.classList.remove('is-busy'); });
      }
    });
    // Enter in the quantity box is the update, not the checkout. Without this the browser's own
    // implicit submission runs the form's first submit button, which is Checkout, and typing a
    // quantity and pressing Enter took you straight out of the cart.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var d = root(); if (!d || !d.contains(e.target)) return;
      if (!e.target.matches('[data-qty-input]')) return;
      e.preventDefault();
      var li = e.target.closest('.cartd__item');
      changeLine(li, capped(li, e.target.value));
    });

    // backordered line: join the notify list without leaving the drawer
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-notify]'); var d = root();
      if (!f || !d || !d.contains(f)) return;
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]'); btn.disabled = true;
      fetch(f.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(f), headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
        .then(function (r) {
          // a post Shopify took comes back as the page with ?customer_posted=true; anything else (a captcha, a bad email) goes the ordinary way
          if (!r.ok || r.url.indexOf('customer_posted=true') === -1) throw new Error('not posted');
          f.classList.add('is-done'); f.querySelector('.cartd__notify-ok').hidden = false;
        })
        .catch(function () { btn.disabled = false; f.removeAttribute('data-notify'); f.submit(); });  // the ordinary way, with a page load
    });
    document.addEventListener('change', function (e) {
      var d = root(); if (!d || !d.contains(e.target)) return;
      if (e.target.matches('[data-qty-input]')) {
        var qli = e.target.closest('.cartd__item');
        changeLine(qli, capped(qli, e.target.value));
      }
      if (e.target.matches('[data-note]')) post('cart/update.js', { note: e.target.value }).then(function () {
        var s = e.target.closest('details').querySelector('summary');
        if (s) s.textContent = e.target.value.trim() ? 'Gift note added' : 'Add a gift note';
      });
    });
    // header count follows the cart
    document.addEventListener('cart:updated', function (e) {
      var cart = e.detail; if (!cart || typeof cart.item_count !== 'number') return;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // the quick order: piece, colour, size; the chosen variant goes straight into the cart drawer
    function initOrder(order) {
      var chips = order.querySelectorAll('[data-piece-chip]'), dots = order.querySelector('[data-dots]'), sizeRow = order.querySelector('[data-sizes]'), sizes = order.querySelectorAll('[data-size]');
      var add = order.querySelector('[data-add]'), label = order.querySelector('[data-add-label]'), see = order.querySelector('[data-see]'), err = order.querySelector('[data-err]');
      var colour = null, size = null;
      function sync() {
        var chip = order.querySelector('[data-piece-chip].is-on');
        if (!chip) return;
        var variants = JSON.parse(chip.getAttribute('data-variants') || '[]');
        var colours = [];
        variants.forEach(function (v) { if (colours.indexOf(v.c) < 0) colours.push(v.c); });
        // the colour carries across pieces when the new piece has it; otherwise its first
        if (colours.indexOf(colour) < 0) colour = colours[0] || null;
        if (dots) {
          dots.hidden = colours.length < 2;
          dots.querySelectorAll('[data-colour]').forEach(function (b) {
            var c = b.getAttribute('data-colour'), has = colours.indexOf(c) >= 0;
            b.hidden = !has; b.classList.toggle('is-on', c === colour); b.setAttribute('aria-pressed', c === colour ? 'true' : 'false');
          });
        }
        // sizes this piece doesn't come in go faint; the chosen size carries across too
        sizes.forEach(function (b) {
          var s = b.getAttribute('data-size'), ok = variants.some(function (v) { return v.c === colour && v.s === s; });
          b.classList.toggle('is-out', !ok); b.disabled = !ok;
          var on = ok && s === size;
          b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var hit = size && variants.find(function (v) { return v.c === colour && v.s === size; });
        add.setAttribute('data-variant', hit ? hit.id : '');
        if (hit) { add.removeAttribute('data-needs-size'); label.textContent = 'Add to cart · ' + chip.getAttribute('data-price'); }
        else { add.setAttribute('data-needs-size', ''); label.textContent = 'Select a size'; }
        if (see) { see.href = chip.getAttribute('data-url'); see.textContent = 'See the ' + (chip.getAttribute('data-short') || 'piece').toLowerCase(); }
      }
      function nudge() {
        if (!sizeRow) return;
        sizeRow.classList.remove('is-nudge'); void sizeRow.offsetWidth; sizeRow.classList.add('is-nudge');
        setTimeout(function () { sizeRow.classList.remove('is-nudge'); }, 800);
      }
      function addIt() {
        var id = Number(add.getAttribute('data-variant'));
        if (!id) { nudge(); return; }
        add.disabled = true; err.hidden = true;
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer' })
        }).then(function (r) { return r.json(); }).then(function (data) {
          add.disabled = false;
          if (data.status || data.message) { err.textContent = data.description || data.message; err.hidden = false; return; }
          var drawer = document.getElementById('cart-drawer');
          if (data.sections && data.sections['cart-drawer'] && drawer) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data.sections['cart-drawer'];
            var fresh = tmp.querySelector('#cart-drawer');
            if (fresh) drawer.innerHTML = fresh.innerHTML;
          }
          // the header count follows the cart, so fetch it and announce it
          return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); })
            .then(function () { var opener = document.querySelector('[data-open="cart-drawer"]'); if (opener) opener.click(); });
        }).catch(function () { add.disabled = false; err.textContent = "Couldn't add that just now. Try again?"; err.hidden = false; });
      }
      order.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-piece-chip]');
        if (chip) { chips.forEach(function (c) { c.classList.toggle('is-on', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); }); sync(); return; }
        var dot = e.target.closest('[data-colour]');
        if (dot) { colour = dot.getAttribute('data-colour'); sync(); return; }
        var sz = e.target.closest('[data-size]');
        if (sz) { if (!sz.disabled) { size = sz.getAttribute('data-size'); sync(); } return; }
        if (e.target.closest('[data-add]')) addIt();
      });
      sync();
    }

    document.querySelectorAll('[data-designs]').forEach(function (sec) {
      var depts = sec.querySelectorAll('[data-dept]'), strips = sec.querySelectorAll('[data-strip]'), countOut = sec.querySelector('[data-count-out]');
      var pic = sec.querySelector('[data-pic]'), art = pic && pic.querySelector('.ds__art'), panels = sec.querySelector('[data-panels]');
      var dlg = sec.querySelector('[data-dialog]'), dlgArt = dlg && dlg.querySelector('.ds__dialog-art'), dlgCap = dlg && dlg.querySelector('[data-dialog-cap]');
      var cache = {}, current = null, want = null;
      function artUrl(base, w) { return base + (base.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
      function stripOf(key) { return sec.querySelector('[data-strip="' + key + '"]'); }

      // the print swaps from the tile's URL once the new one has loaded, so it never flashes empty
      function showPrint(tile) {
        if (!art) return;
        var base = tile.getAttribute('data-art'), name = tile.getAttribute('data-name');
        if (!base) return;
        var img = new Image();
        img.onload = function () {
          if (want !== tile) return;
          pic.classList.remove('is-fresh');
          art.srcset = artUrl(base, 600) + ' 600w, ' + artUrl(base, 900) + ' 900w, ' + artUrl(base, 1200) + ' 1200w';
          art.src = artUrl(base, 1200); art.alt = name;
          pic.classList.remove('is-swapping'); void pic.offsetWidth; pic.classList.add('is-fresh');
        };
        pic.classList.add('is-swapping');
        img.src = artUrl(base, 1200);
        pic.setAttribute('aria-label', 'See the ' + name + ' print large');
        if (dlgArt) { dlgArt.src = artUrl(base, 2000); dlgArt.alt = name; }
        if (dlgCap) dlgCap.textContent = name;
      }
      // the words and the order for a design come rendered from its own page; each is fetched once
      function showPanel(tile) {
        var handle = tile.getAttribute('data-design'), url = tile.getAttribute('data-url');
        function place(html) {
          if (want !== tile) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-panel]');
          if (!fresh) return;
          panels.replaceChildren(fresh);
          panels.classList.remove('is-busy');
          fresh.classList.add('is-fresh');
          var order = fresh.querySelector('[data-order]');
          if (order) initOrder(order);
        }
        if (cache[handle]) { place(cache[handle]); return; }
        panels.classList.add('is-busy');
        fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=design-order', { headers: { 'Accept': 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) { cache[handle] = html; place(html); })
          .catch(function () { panels.classList.remove('is-busy'); if (want === tile) location.href = url; });
      }
      // Move the thumbnail column, never the page. scrollIntoView walks every scrollable ancestor it can
      // find, so on load it dragged the whole home page down to this section and the hero was never seen.
      function stripTo(strip, tile) {
        if (!strip || !tile) return;
        var top = tile.getBoundingClientRect().top - strip.getBoundingClientRect().top + strip.scrollTop;
        top = top - (strip.clientHeight - tile.offsetHeight) / 2;
        strip.scrollTop = Math.max(0, Math.min(top, strip.scrollHeight - strip.clientHeight));
      }
      function pick(tile, focus) {
        if (!tile) return;
        want = tile;
        var strip = tile.closest('[data-strip]');
        strip.querySelectorAll('[data-tile]').forEach(function (t) {
          var on = t === tile;
          t.classList.toggle('is-on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        });
        if (focus) tile.focus({ preventScroll: true });
        stripTo(strip, tile);
        if (tile === current) return;
        current = tile;
        showPrint(tile);
        var shown = panels.querySelector('[data-panel]');
        if (shown && shown.getAttribute('data-design') === tile.getAttribute('data-design')) return;
        showPanel(tile);
      }
      function showDept(key, focus) {
        depts.forEach(function (d) {
          var on = d.getAttribute('data-dept') === key;
          d.classList.toggle('is-on', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); d.tabIndex = on ? 0 : -1;
          if (on && focus) d.focus();
        });
        strips.forEach(function (s) { s.hidden = s.getAttribute('data-strip') !== key; });
        var strip = stripOf(key);
        if (!strip) return;
        if (countOut) countOut.textContent = strip.getAttribute('data-count') + ' designs';
        // the department's chosen print, else its best seller
        pick(strip.querySelector('[data-tile].is-on') || strip.querySelector('[data-tile]'), false);
      }
      depts.forEach(function (d, i) {
        d.addEventListener('click', function () { showDept(d.getAttribute('data-dept'), false); });
        d.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var next = depts[(i + (e.key === 'ArrowRight' ? 1 : depts.length - 1)) % depts.length];
          showDept(next.getAttribute('data-dept'), true);
        });
      });
      sec.addEventListener('click', function (e) {
        var tile = e.target.closest('[data-tile]');
        if (tile) pick(tile, false);
      });
      // arrows walk the strip from the chosen print
      sec.addEventListener('keydown', function (e) {
        var tile = e.target.closest('[data-tile]');
        if (!tile) return;
        var fwd = e.key === 'ArrowDown' || e.key === 'ArrowRight', back = e.key === 'ArrowUp' || e.key === 'ArrowLeft';
        if (!fwd && !back) return;
        e.preventDefault();
        var tiles = Array.prototype.slice.call(tile.closest('[data-strip]').querySelectorAll('[data-tile]')), i = tiles.indexOf(tile);
        pick(tiles[(i + (fwd ? 1 : tiles.length - 1)) % tiles.length], true);
      });
      // the print, large
      if (pic && dlg && dlg.showModal) {
        pic.addEventListener('click', function () { dlg.showModal(); });
        dlg.querySelector('[data-dialog-close]').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      }
      // the opening state: the open department's chosen print is the one the panel was rendered for
      var opening = panels.querySelector('[data-panel]'), openStrip = sec.querySelector('[data-strip]:not([hidden])');
      if (opening && openStrip) {
        var tile = openStrip.querySelector('[data-tile][data-design="' + opening.getAttribute('data-design') + '"]') || openStrip.querySelector('[data-tile]');
        if (tile) {
          current = tile; want = tile;
          openStrip.querySelectorAll('[data-tile]').forEach(function (t) { var on = t === tile; t.classList.toggle('is-on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
          stripTo(openStrip, tile);
        }
        var order = opening.querySelector('[data-order]');
        if (order) initOrder(order);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["family-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-band]').forEach(function (band) {
      var list = band.querySelector('[data-list]'), rule = band.querySelector('[data-rule]');
      if (!list || !rule) return;
      var home = list.querySelector('.is-current [data-go]');
      function moveTo(el) {
        if (!el) { rule.classList.remove('is-on'); return; }
        var r = el.getBoundingClientRect(), l = list.getBoundingClientRect();
        rule.style.left = (r.left - l.left) + 'px'; rule.style.width = r.width + 'px'; rule.classList.add('is-on');
      }
      list.querySelectorAll('[data-go]').forEach(function (a) {
        a.addEventListener('mouseenter', function () { moveTo(a); });
        a.addEventListener('focus', function () { moveTo(a); });
      });
      list.addEventListener('mouseleave', function () { moveTo(home); });
      list.addEventListener('focusout', function (e) { if (!list.contains(e.relatedTarget)) moveTo(home); });
      if (home) { moveTo(home); rule.style.transition = 'none'; requestAnimationFrame(function () { rule.style.transition = ''; }); }
      window.addEventListener('resize', function () { moveTo(list.querySelector('[data-go]:hover') || home); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-pieces"] && !Shopify.designMode) return;
  try {
    
  // a phone swipes the tile's layer between the shot and the product photo: the dots and the words follow
  document.addEventListener('scroll', function (e) {
    var pics = e.target;
    if (!pics || !pics.hasAttribute || !pics.hasAttribute('data-pics')) return;
    var tile = pics.closest('.fp__tile'), i = pics.clientWidth ? Math.round(pics.scrollLeft / pics.clientWidth) : 0;
    if (!tile) return;
    tile.classList.toggle('is-flipped', i > 0);
    tile.classList.toggle('is-end', pics.scrollLeft + pics.clientWidth >= pics.scrollWidth - 1.5);
    tile.querySelectorAll('.fp__dots i').forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-signup]');
    if (!form) return;
    var fields = form.querySelector('[data-signup-fields]');
    var done = form.querySelector('[data-signup-done]');
    var err = form.querySelector('[data-signup-err]');
    // Every customer form on the page reads "posted" after any one of them posts the ordinary way
    // (the backorder notify box, say) — Shopify can't tell them apart, but the URL carries the
    // posting form's anchor, so a reload that names someone else folds this thank-you back up.
    if (!done.hidden && location.hash && location.hash !== '#FooterSignup') { done.hidden = true; fields.hidden = false; }
    // Posts without leaving the page and swaps in the thank-you. Shopify answers a good signup with
    // a redirect back here carrying ?customer_posted=true, a bad address with the page again (its
    // errors in it), and — when its spam check wants a word — with a redirect to its /challenge
    // page: then the visitor is sent to that page, once, and Shopify brings them back here with
    // ?customer_posted=true to the same thank-you, rendered by Liquid. Anything else unexpected
    // goes the ordinary way with a page load. A form its spam check has already taken hold of
    // (the data-*-bound flags) is left to it from the start.
    // The event stops here: Shopify's own script listens on the document and, for any contact or
    // customer form, re-submits it itself with a page load — let it through and the page reloads
    // under the in-place post. Two things that script does on the way out are done here instead,
    // because Shopify's side counts on them: a form_key on the post (without one the store answers
    // 400 "invalid parameters"), and the fields stashed in sessionStorage under that key — the
    // /challenge page arrives as an empty form and fills itself in from that stash (its action,
    // the fields, where to return to); without it the challenge posts to itself and 404s.
    form.addEventListener('submit', function (e) {
      if (form.dataset.plain || form.dataset.hcaptchaBound || form.dataset.recaptchaBound) return;
      e.preventDefault();
      e.stopPropagation();
      var key = form.elements.form_key;
      if (!key) { key = document.createElement('input'); key.type = 'hidden'; key.name = 'form_key'; form.appendChild(key); }
      key.value = Array.from(Array(32), function () { return Math.random().toString(36)[2]; }).join('');
      var body = new FormData(form), data = {};
      body.forEach(function (v, k) { data[k] = v; });
      try { sessionStorage.setItem(key.value, JSON.stringify({ __shopify_v: 1, action: form.action, data: data })); } catch (x) {}
      var btn = fields.querySelector('button[type="submit"]');
      btn.disabled = true; err.hidden = true;
      fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: body, headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('bad');
          var url = new URL(r.url, location.href);
          if (url.searchParams.get('customer_posted') === 'true') return null;
          if (url.pathname.indexOf('/challenge') === 0) { location.assign(url.href + '#' + form.id); return false; }
          return r.text();
        })
        .then(function (html) {
          if (html === false) return;  // on the way to the challenge
          if (html === null) { fields.hidden = true; done.hidden = false; done.focus({ preventScroll: true }); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if (!doc.querySelector('[data-signup]')) throw new Error('not ours');  // some other page (a bot check, say): the ordinary way
          var again = doc.querySelector('[data-signup-err]');
          var msg = again ? again.textContent.trim() : '';
          err.textContent = msg || "That email didn't go through. Check it and try again.";
          err.hidden = false; btn.disabled = false;
        })
        .catch(function () { btn.disabled = false; form.dataset.plain = '1'; form.submit(); });
    });
    // the code chip copies itself; where the clipboard is off limits it selects the code instead
    form.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-copy]');
      if (!chip) return;
      var code = chip.getAttribute('data-copy'), act = chip.querySelector('.ftr__code-act');
      function select() {
        var range = document.createRange(); range.selectNodeContents(chip.querySelector('.ftr__code-val'));
        var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
      }
      function copied() {
        chip.classList.add('is-copied'); act.textContent = 'Copied';
        setTimeout(function () { chip.classList.remove('is-copied'); act.textContent = 'Copy'; }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(copied, select);
      else select();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // The way into a menu from the keyboard. Its links sit at tabindex -1 so that tabbing across the
    // bar doesn't walk all fifty of them (see header-panel.liquid); Down, or Enter held open with
    // Alt, lets them in, Escape hands focus back to the word it came from, and leaving closes it
    // again. Nothing here runs for a mouse or a finger: those never needed it.
    (function () {
      var openItem = null;
      function rows(item) { return item.querySelectorAll('.hdr__panel-list a'); }
      function setOpen(item, on) {
        if (!item) return;
        item.classList.toggle('is-open', on);
        rows(item).forEach(function (a) { a.setAttribute('tabindex', on ? '0' : '-1'); });
        if (!on && openItem === item) openItem = null;
        if (on) openItem = item;
      }
      document.addEventListener('keydown', function (e) {
        var item = e.target.closest ? e.target.closest('.hdr__item.has-sub') : null;
        if (e.key === 'Escape' && openItem) {
          var top = openItem.querySelector(':scope > a');
          setOpen(openItem, false);
          if (top) top.focus();
          return;
        }
        if (!item || !item.querySelector('.hdr__panel')) return;
        var onTop = e.target === item.querySelector(':scope > a');
        if (e.key === 'ArrowDown' && onTop) {
          e.preventDefault();
          setOpen(item, true);
          // nothing inside a visibility:hidden subtree can take focus, and the class has only just
          // landed; reading a layout property forces the style through first. rAF would do it too,
          // but not in a tab the browser has put to sleep.
          var first = rows(item)[0];
          if (first) { void item.offsetWidth; first.focus(); }
        }
      });
      // focus left the menu entirely: put it back the way it was
      document.addEventListener('focusin', function (e) {
        if (openItem && !openItem.contains(e.target)) setOpen(openItem, false);
      });
    })();

    var lastFocus = null;
    // drawers that live inside a page section (the filter drawer) would be trapped under the header by
    // that section's stacking context (the pinned hero gives every section z-index 1): lift them to body
    document.querySelectorAll('main .drawer').forEach(function (d) { document.body.appendChild(d); });
    function open(id, trigger) {
      var d = document.getElementById(id);
      if (!d) return;
      lastFocus = trigger || document.activeElement;
      d.hidden = false;
      document.body.style.overflow = 'hidden';
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var f = d.querySelector('[data-close], a, button');
      if (f) f.focus();
    }
    function closeAll() {
      document.querySelectorAll('.drawer:not([hidden])').forEach(function (d) { d.hidden = true; });
      document.body.style.overflow = '';
      document.querySelectorAll('[data-open][aria-expanded]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) { lastFocus.focus(); lastFocus = null; }
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open]');
      if (opener) {
        var id = opener.getAttribute('data-open');
        // let the cart link behave normally if the drawer isn't present
        if (document.getElementById(id)) { e.preventDefault(); open(id, opener); }
        return;
      }
      if (e.target.closest('[data-close]') || e.target.classList.contains('drawer__scrim')) { closeAll(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    // Shrink on the way down, grow on the way up; solid once the page has moved.
    var hdr = document.querySelector('[data-hdr]');
    if (hdr) {
      // the bar only changes size after a clear move (24px) in one direction, so trackpad jitter
      // around the threshold can't flip it back and forth; the same clear move separates the depth
      // it shrinks at (past 164) from the depth it is always tall above (140), so jitter on one line
      // can't reach the other
      var ticking = false, compact = false, anchor = window.scrollY;   // anchor: the turning point of the last run
      var update = function () {
        var y = window.scrollY;
        hdr.classList.toggle('is-scrolled', y > 8);
        if (compact) {
          if (y > anchor) anchor = y;                                   // still heading down: the peak moves
          if (y <= 140 || y < anchor - 24) { compact = false; anchor = y; hdr.classList.remove('is-compact'); }
        } else {
          if (y < anchor) anchor = y;                                   // still heading up: the trough moves
          if (y > 164 && y > anchor + 24) { compact = true; anchor = y; hdr.classList.add('is-compact'); }
        }
        ticking = false;
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-club-product"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-club-product]');
  if (!root) return;
  var node = root.querySelector('[data-club-data]');
  if (!node) return;
  var DATA;
  try { DATA = JSON.parse(node.textContent); } catch (e) { return; }
  if (!DATA.pairings || !DATA.pairings.length) return;

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  // what the builder calls a piece with one mark on it, so a club order reads the same whichever
  // route it came through: the press reads these two lines and nothing else
  var EXTRAS = 'No extras';
  var DOT = ' · ';

  var sel = {
    mark: root.getAttribute('data-mark'),
    colour: root.getAttribute('data-colour'),
    size: null
  };

  function pairing(code, colour) {
    for (var i = 0; i < DATA.pairings.length; i++) {
      if (DATA.pairings[i].code === code && DATA.pairings[i].colour === colour) return DATA.pairings[i];
    }
    return null;
  }
  function coloursFor(code) {
    return DATA.pairings.filter(function (p) { return p.code === code; })
                        .map(function (p) { return p.colour; });
  }

  /* ---- the photographs, the name, and the placement under it ---- */
  function paintPair() {
    var want = sel.mark, col = sel.colour;
    $$('[data-for-mark]').forEach(function (el) {
      el.hidden = !(el.getAttribute('data-for-mark') === want && el.getAttribute('data-for-colour') === col);
    });
    var p = pairing(want, col);
    if (!p) return;
    $('[data-mark-name]').textContent = p.name;
    var crumb = $('[data-crumb-name]');
    if (crumb) crumb.textContent = p.name;
    var slot = $('[data-slot-label]');
    if (slot) slot.textContent = p.label;
    // the row below offers the whole store, so take out the one card that is this page
    var here = window.location.pathname;
    $$('.hv__more .hv__best-cell').forEach(function (li) {
      var a = li.querySelector('a.card__link');
      if (!a) return;
      var bits = (a.getAttribute('href') || '').split('?mark=');
      li.hidden = bits[0] === here && bits[1] === want;
    });
    // the tab says which pairing this is, keeping whatever the shop put after the first separator
    var tail = document.title.split(' · ').slice(1).join(' · ');
    document.title = tail ? p.name + ' · ' + tail : p.name;
  }

  /* ---- which variant a colour and a size make, and what it costs ---- */
  function variantFor(size) {
    var ci = DATA.colourIndex, si = DATA.sizeIndex, ei = DATA.extrasIndex, hit = null;
    DATA.variants.forEach(function (v) {
      if (hit) return;
      if (si >= 0 && v.opts[si] !== size) return;
      if (ci >= 0 && v.opts[ci] !== sel.colour) return;
      if (ei >= 0 && v.opts[ei] !== EXTRAS) return;
      hit = v;
    });
    return hit;
  }
  function money(cents) {
    var f = (Number(cents) / 100).toFixed(2);
    return '$' + f.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function paintBuy() {
    // a size this colour cannot be had in is said so rather than failing at the press
    $$('[data-size-in]').forEach(function (i) {
      var v = variantFor(i.value);
      i.disabled = !(v && v.available);
    });
    var cur = $('[data-size-in]:checked');
    if (cur && cur.disabled) { cur.checked = false; sel.size = null; }
    var v = sel.size ? variantFor(sel.size) : null;
    var price = $('[data-price]');
    if (v && price) price.textContent = money(v.price);
    var szv = $('[data-size-val]');
    if (szv) szv.textContent = sel.size || '';
    var btn = $('[data-add]'), label = $('[data-add-label]');
    if (v && v.available) {
      btn.removeAttribute('data-needs-size');
      label.textContent = 'Add to cart';
    } else {
      btn.setAttribute('data-needs-size', '');
      label.textContent = sel.size ? 'Sold out' : 'Select a size';
    }
  }
  // A mark cannot print on a garment its own colour, so GSGE's wordmark is three marks and not one:
  // bronze goes on both, white goes on black only, black goes on white only. Where the mark decides
  // the colour there is nothing to choose, so the swatches go away and the colour is stated in the
  // line under the title instead. A disabled swatch would be a dead end: this page carries one mark
  // and has no way to offer the other ink.
  function paintColours() {
    var ok = coloursFor(sel.mark);
    if (ok.indexOf(sel.colour) < 0 && ok.length) sel.colour = ok[0];
    var row = $('[data-colour-row]'), said = $('[data-colour-said]');
    if (row) row.hidden = ok.length < 2;
    if (said) {
      said.hidden = !(ok.length < 2 && sel.colour && sel.colour !== '-');
      said.textContent = said.hidden ? '' : ' \u00b7 ' + sel.colour;
    }
    $$('[data-colour-in]').forEach(function (i) {
      i.disabled = ok.indexOf(i.value) < 0;
      if (i.value === sel.colour) i.checked = true;
    });
    var cv = $('[data-colour-val]');
    if (cv) cv.textContent = sel.colour;
  }

  /* ---- the mark asked for in the URL ---- */
  var asked = (location.search.match(/[?&]mark=([^&]+)/) || [])[1];
  if (asked) {
    asked = decodeURIComponent(asked).toUpperCase();
    if (coloursFor(asked).length) sel.mark = asked;
  }

  paintColours();
  paintPair();
  paintBuy();

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-colour-in]')) {
      sel.colour = e.target.value;
      paintColours();
      paintPair();
      paintBuy();
    } else if (e.target.matches('[data-size-in]')) {
      sel.size = e.target.value;
      var done = $('[data-added]');
      if (done) done.hidden = true;
      paintBuy();
    }
  });

  // the rail scrolls the stack, the way the product page's own rail does
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var fig = document.getElementById(t.getAttribute('data-thumb'));
    if (!fig) return;
    e.preventDefault();
    fig.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  /* ---- adding it ---- */
  function nudge() {
    var row = $('[data-size-row]');
    if (!row) return;
    row.classList.add('is-nudge');
    setTimeout(function () { row.classList.remove('is-nudge'); }, 900);
  }
  $('[data-club-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var err = $('[data-err]'), btn = $('[data-add]');
    var v = sel.size ? variantFor(sel.size) : null;
    if (!v || !v.available) { nudge(); return; }
    var p = pairing(sel.mark, sel.colour);
    if (!p) { nudge(); return; }
    // the store rides along under an underscore so the cart keeps it out of the customer's sight,
    // and the mark is keyed by its placement, exactly as the builder writes it
    var props = { '_shop': root.getAttribute('data-shop') };
    props[p.label + ' mark'] = p.code + DOT + p.name;

    err.hidden = true;
    btn.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }], sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (data) {
      btn.disabled = false;
      if (data.status || data.message) {
        err.textContent = data.description || data.message;
        err.hidden = false;
        return;
      }
      var drawer = document.getElementById('cart-drawer');
      if (data.sections && data.sections['cart-drawer'] && drawer) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data.sections['cart-drawer'];
        var fresh = tmp.querySelector('#cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
      var done = $('[data-added]');
      if (done) {
        done.textContent = sel.size + ' is in your cart. Pick another size to add one more.';
        done.hidden = false;
      }
      var opener = document.querySelector('[data-open="cart-drawer"]');
      if (opener) opener.click();
    }).catch(function () {
      btn.disabled = false;
      err.textContent = "Couldn't add that just now. Try again?";
      err.hidden = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    // the bar sits under the header, whatever height the header is at the moment (the bar itself:
    // its section stays the tall height while the bar shrinks)
    var hdr = document.querySelector('.hdr');
    function hdrNow() { return hdr ? hdr.getBoundingClientRect().height : 0; }
    if (hdr && 'ResizeObserver' in window) {
      new ResizeObserver(function () { document.documentElement.style.setProperty('--hdr-now', hdrNow() + 'px'); }).observe(hdr);
    }
    var coll = document.querySelector('.coll');
    if (!coll) return;
    var wrap = coll.closest('.shopify-section');
    var sectionId = wrap && wrap.id.replace('shopify-section-', '');

    // pickers: one open at a time; while one is open the section rises over the header (the phone sheet)
    function picks() { return document.querySelectorAll('.coll [data-pick]'); }
    function closeAll(except) {
      picks().forEach(function (p) { if (p !== except) p.removeAttribute('open'); });
      if (wrap) wrap.classList.toggle('is-raised', !!except);
    }
    document.addEventListener('click', function (e) {
      var pick = e.target.closest('.coll [data-pick]');
      if (!pick) { closeAll(null); return; }
      if (e.target.closest('[data-pick-close]')) { closeAll(null); return; }
      // the scrim on a phone is the details' own ::before, so a tap on it lands on the details itself
      if (e.target === pick) { closeAll(null); return; }
      if (e.target.closest('summary')) {
        // the browser flips 'open' after this handler: settle the others once it has
        requestAnimationFrame(function () { closeAll(pick.open ? pick : null); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

    // a word, a picker option or a page link swaps the section in place instead of reloading the page,
    // so nothing jumps back to the top; the bar stays put and the grid changes under it
    function load(url, push) {
      if (!sectionId || !window.fetch) { location.href = url; return; }
      var u = new URL(url, location.href), f = new URL(u.href);
      f.searchParams.set('section_id', sectionId);
      wrap.classList.add('is-busy');
      fetch(f.href, { headers: { 'Accept': 'text/html' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.coll');
        if (!fresh) throw new Error('no section');
        var cur = wrap.querySelector('.coll');
        cur.replaceWith(fresh);
        wrap.classList.remove('is-busy', 'is-raised');
        if (fresh.dataset.title) document.title = fresh.dataset.title;
        if (push) history.pushState({ coll: u.href }, '', u.href);
        // keep the bar where it was on screen: under the header, unless the page is still above it
        var bar = wrap.querySelector('[data-bar] .coll__pieces') || wrap.querySelector('[data-bar]');
        if (bar) {
          var top = bar.getBoundingClientRect().top + window.scrollY - hdrNow();
          if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'instant' });
        }
      }).catch(function () { location.href = u.href; });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.coll [data-bar] a[href], .coll .coll__view a[href], .coll .pager a[href]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || a.target === '_blank') return;
      e.preventDefault();
      load(href, true);
    });
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.coll) load(e.state.coll, false);
      else if (history.state === null && location.pathname.indexOf('/collections/') === 0) load(location.href, false);
    });
    history.replaceState({ coll: location.href }, '', location.href);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-hive"]) return;
  try {
    
  // the form: the store's few extra questions appear when a store is chosen (the inquiry itself goes the
  // ordinary way, to the store's contact inbox — Justis, 20 Sep: we work from the inbox)
  document.querySelectorAll('#hive-form').forEach(function (form) {
    var kind = form.querySelector('#hv-kind'), store = form.querySelector('[data-hv-store]');
    if (!kind || !store) return;
    var sync = function () { store.hidden = kind.value !== 'A store of our own'; };
    kind.addEventListener('change', sync);
    sync();
  });
  // the framed snapshot: the card at a laptop's width, scaled to the frame and cut to a screen's shape
  // from 48rem up; on a phone it simply renders at the phone's width, which is what that store looks like
  // on a phone
  (function () {
    var snaps = document.querySelectorAll('[data-hv-snap]');
    if (!snaps.length) return;
    var W = 1040;
    function fit() {
      var wide = window.matchMedia('(min-width: 48rem)').matches;
      snaps.forEach(function (snap) {
        var view = snap.querySelector('.hv__snap-view'), inner = snap.querySelector('[data-hv-snap-in]');
        if (!view || !inner) return;
        if (!wide) { inner.style.width = ''; inner.style.transform = ''; view.style.height = Math.round(Math.min(inner.offsetHeight, view.clientWidth * 1.5)) + 'px'; return; }
        var k = view.clientWidth / W;
        inner.style.width = W + 'px';
        inner.style.transform = 'scale(' + k + ')';
        // a laptop screen's shape: the top of the card, the rest below the fold, as a screenshot would be
        view.style.height = Math.round(Math.min(inner.offsetHeight * k, view.clientWidth * 0.66)) + 'px';
      });
    }
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    var wrap = document.querySelector('[data-hv-snap-in]');
    if (wrap && 'ResizeObserver' in window) new ResizeObserver(fit).observe(wrap);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var form = root.querySelector('[data-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var labels = root.querySelectorAll('[data-add-label]');
    var prices = root.querySelectorAll('[data-price]');
    var err = root.querySelector('[data-err]');
    var opts = root.querySelectorAll('[data-option]');
    var sizeRow = root.querySelector('[data-size-row]');
    var nnRow = root.querySelector('[data-nn-row]');

    function chosen() {
      var out = {};
      opts.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        out[fs.getAttribute('data-option')] = c ? c.value : null;
        var v = fs.querySelector('[data-opt-val]');
        if (v) v.textContent = c ? c.value : '';
      });
      return out;
    }
    function find(o) {
      return variants.find(function (v) {
        return v.o1 === o['1']
          && (o['2'] == null ? true : v.o2 === o['2'])
          && (o['3'] == null ? true : v.o3 === o['3']);
      });
    }
    function paint(ev) {
      var o = chosen();
      // The name and number boxes belong to the extras value that asks for them. Disabled
      // rather than merely hidden: a hidden input still posts, and two blank properties on
      // every plain order would have the press looking for a name nobody typed.
      if (nnRow) {
        var wantsName = (o['3'] || '').toLowerCase().indexOf('name') > -1;
        nnRow.hidden = !wantsName;
        nnRow.querySelectorAll('input').forEach(function (i) { i.disabled = !wantsName; });
      }
      var needSize = sizeRow && !o['2'];
      var v = needSize ? null : find(o);
      // grey out sizes unavailable in the chosen colour
      if (sizeRow) {
        sizeRow.querySelectorAll('.sz').forEach(function (lab) {
          var val = lab.querySelector('input').value;
          var m = variants.find(function (x) {
            return x.o1 === o['1'] && x.o2 === val
              && (o['3'] == null ? true : x.o3 === o['3']);
          });
          lab.classList.toggle('is-out', !(m && m.available));
        });
      }
      if (needSize) {
        addBtn.setAttribute('data-needs-size', '');
        labels.forEach(function (l) { l.textContent = 'Select a size'; });
        idInput.value = '';
      } else if (v && v.available) {
        addBtn.removeAttribute('data-needs-size');
        labels.forEach(function (l) { l.textContent = 'Add to cart'; });
        idInput.value = v.id;
        prices.forEach(function (p) { p.textContent = v.price; });
      } else {
        addBtn.setAttribute('data-needs-size', '');
        labels.forEach(function (l) { l.textContent = 'Sold out'; });
        idInput.value = v ? v.id : '';
      }
      // show only the chosen colour's photos (untagged photos and the artwork show for every colour)
      showColour(o['1'], !!ev);
    }
    var track = root.querySelector('[data-track]');
    var dotsBox = root.querySelector('[data-dots]');
    var thumbsBox = root.querySelector('[data-thumbs]');
    function showColour(colour, reset) {
      if (!track) return;
      var c = (colour || '').toLowerCase();
      var slides = Array.prototype.slice.call(track.querySelectorAll('.pdp__slide'));
      var tagged = slides.some(function (s) { return s.getAttribute('data-colour') === c; });
      slides.forEach(function (s) {
        var sc = s.getAttribute('data-colour');
        s.hidden = !!(tagged && sc && sc !== c);
        if (s.hasAttribute('data-art')) s.classList.toggle('is-white', c === 'white');
      });
      var shown = slides.filter(function (s) { return !s.hidden; });
      if (dotsBox) {
        dotsBox.innerHTML = shown.length > 1 ? shown.map(function (_, i) { return '<span class="pdp__dot' + (i === 0 ? ' is-on' : '') + '"></span>'; }).join('') : '';
      }
      // the rail follows the stack, or it offers a photo that isn't there any more
      if (thumbsBox) {
        var up = 0;
        Array.prototype.forEach.call(thumbsBox.querySelectorAll('[data-thumb]'), function (t) {
          var tc = t.getAttribute('data-colour');
          t.hidden = !!(tagged && tc && tc !== c);
          if (t.classList.contains('pdp__thumb--art')) t.classList.toggle('is-white', c === 'white');
          if (!t.hidden) up++;
        });
        thumbsBox.hidden = up < 2;
      }
      if (reset) track.scrollTo({ left: 0 });
    }
    // arriving from another piece: pick up the colour and size chosen there
    try {
      var qs = new URLSearchParams(location.search);
      opts.forEach(function (fs) {
        var want = fs.getAttribute('data-option') === '1' ? qs.get('colour') : qs.get('size');
        if (!want) return;
        var hit = Array.prototype.find.call(fs.querySelectorAll('input'), function (i) { return i.value.toLowerCase() === want.toLowerCase(); });
        if (hit) hit.checked = true;
      });
    } catch (e) {}
    opts.forEach(function (fs) { fs.addEventListener('change', paint); });
    paint();

    // moving to another piece keeps the colour and size
    root.querySelectorAll('[data-piece]').forEach(function (a) {
      a.addEventListener('click', function () {
        var o = chosen(), u = new URL(a.href, location.href);
        if (o['1']) u.searchParams.set('colour', o['1']);
        if (o['2']) u.searchParams.set('size', o['2']);
        a.href = u.toString();
      });
    });

    // the info column sticks; taller than the window, it sticks by its bottom instead so nothing is out of reach
    var info = root.querySelector('.pdp__info');
    function stickBy() {
      if (!info || window.matchMedia('(max-width: 52rem)').matches) return;
      var slack = window.innerHeight - info.offsetHeight - 24;
      info.style.top = slack < 24 ? slack + 'px' : '';
    }
    stickBy();
    window.addEventListener('resize', stickBy);
    if ('ResizeObserver' in window) new ResizeObserver(stickBy).observe(info);

    // 'ships in 4–7 business days' becomes the dates themselves
    var ship = root.querySelector('[data-ship]');
    if (ship) {
      var nums = (ship.getAttribute('data-ship') || '').match(/\d+/g);
      if (nums && nums.length) {
        var lo = parseInt(nums[0], 10), hi = parseInt(nums[nums.length - 1], 10);
        function addBiz(days) {
          var d = new Date(); d.setHours(12, 0, 0, 0);
          while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
          return d;
        }
        var a = addBiz(lo), b = addBiz(hi), f = { month: 'short', day: 'numeric' };
        var from = a.toLocaleDateString(undefined, f), to = b.toLocaleDateString(undefined, f);
        if (a.getMonth() === b.getMonth()) to = b.toLocaleDateString(undefined, { day: 'numeric' });
        ship.textContent = 'ships ' + from + '\u2013' + to;
      }
    }

    function nudgeSize() {
      if (!sizeRow) return;
      sizeRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
      sizeRow.classList.add('is-nudge');
      setTimeout(function () { sizeRow.classList.remove('is-nudge'); }, 900);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idInput.value) { nudgeSize(); return; }
      err.hidden = true;
      addBtn.disabled = true;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }], sections: 'cart-drawer' })
      }).then(function (r) { return r.json(); }).then(function (data) {
        addBtn.disabled = false;
        if (data.status || data.message) { err.textContent = data.description || data.message; err.hidden = false; return; }
        var drawer = document.getElementById('cart-drawer');
        if (data.sections && data.sections['cart-drawer'] && drawer) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data.sections['cart-drawer'];
          var fresh = tmp.querySelector('#cart-drawer');
          if (fresh) drawer.innerHTML = fresh.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        var opener = document.querySelector('[data-open="cart-drawer"]');
        if (opener) opener.click();
      }).catch(function () { addBtn.disabled = false; err.textContent = "Couldn't add that just now. Try again?"; err.hidden = false; });
    });

    // backordered: join the notify list in place, no page load (as the cart drawer's notify does)
    var notify = root.querySelector('[data-notify]');
    if (notify) {
      var notifyRow = notify.querySelector('.pdp__notify-row'), notifyOk = notify.querySelector('.pdp__ok'), notifyBtn = notify.querySelector('button[type="submit"]');
      notify.addEventListener('submit', function (e) {
        e.preventDefault();
        notifyBtn.disabled = true;
        fetch(notify.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(notify), headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
          .then(function (r) {
            // a post Shopify took comes back as this page with ?customer_posted=true; anything else (a captcha, a bad email) goes the ordinary way
            if (!r.ok || r.url.indexOf('customer_posted=true') === -1) throw new Error('not posted');
            notifyRow.classList.add('is-done'); notifyOk.hidden = false;
          })
          .catch(function () { notifyBtn.disabled = false; notify.submit(); });   // the ordinary way, with a page load
      });
      // back from a post the ordinary way, Shopify marks every customer form on the page posted, the footer's signup too.
      // The hash names the form that really posted (its action's anchor), so someone else's post folds this one away again
      if (notifyRow.classList.contains('is-done') && location.hash && location.hash !== '#' + notify.id) {
        notifyRow.classList.remove('is-done'); notifyOk.hidden = true; notify.querySelector('details').open = false;
      }
    }

    // sticky bar
    var sticky = root.querySelector('[data-sticky]');
    var stickyBtn = root.querySelector('[data-sticky-add]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top < 0 === false && e.boundingClientRect.top > 0;
      }, { threshold: 0 }).observe(addBtn);
      var stickySizes = root.querySelector('[data-sticky-sizes]');
      function syncStickySizes() {
        if (!stickySizes || !sizeRow) return;
        stickySizes.querySelectorAll('[data-sticky-size]').forEach(function (b) {
          var real = sizeRow.querySelector('input[value="' + b.getAttribute('data-sticky-size').replace(/"/g, '\\"') + '"]');
          var lab = real && real.closest('.sz');
          b.classList.toggle('is-on', !!(real && real.checked));
          b.classList.toggle('is-out', !!(lab && lab.classList.contains('is-out')));
        });
      }
      stickyBtn.addEventListener('click', function () {
        if (!idInput.value) {
          // no size yet: open the sizes in the bar itself (or point at the row when there is no bar of sizes)
          if (stickySizes) { stickySizes.hidden = !stickySizes.hidden; syncStickySizes(); } else { nudgeSize(); }
          return;
        }
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      if (stickySizes) {
        stickySizes.addEventListener('click', function (e) {
          var chip = e.target.closest('[data-sticky-size]');
          if (!chip || !sizeRow) return;
          var real = sizeRow.querySelector('input[value="' + chip.getAttribute('data-sticky-size').replace(/"/g, '\\"') + '"]');
          if (!real) return;
          real.checked = true;
          real.dispatchEvent(new Event('change', { bubbles: true }));
          syncStickySizes();
          if (idInput.value) stickySizes.hidden = true;   // chosen: the bar now says Add to cart
        });
        if (sizeRow) sizeRow.addEventListener('change', syncStickySizes);
      }
    }

    // gallery dots (phone)
    if (track && dotsBox) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dotsBox.querySelectorAll('.pdp__dot').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, { passive: true });
    }

    // the rail: which photo you are in front of, and jumping to one by name
    if (thumbsBox && track) {
      function markThumb(id) {
        Array.prototype.forEach.call(thumbsBox.querySelectorAll('[data-thumb]'), function (t) {
          t.classList.toggle('is-on', t.getAttribute('data-thumb') === id);
        });
      }
      if ('IntersectionObserver' in window) {
        // a thin band across the middle of the window: whichever photo is crossing it is the one
        var crossing = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) markThumb(en.target.id); });
        }, { rootMargin: '-45% 0px -45% 0px' });
        Array.prototype.forEach.call(track.querySelectorAll('.pdp__slide[id]'), function (sl) { crossing.observe(sl); });
      }
      thumbsBox.addEventListener('click', function (e) {
        var a = e.target.closest('[data-thumb]');
        if (!a) return;
        var slide = document.getElementById(a.getAttribute('data-thumb'));
        if (!slide) return;
        // the href is the fallback; taken here so seven thumbs don't pile up in the back button
        e.preventDefault();
        slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
        markThumb(a.getAttribute('data-thumb'));
      });
    }

    // three tabs, one panel
    var tabs = root.querySelector('[data-tabs]');
    if (tabs) {
      var tabBtns = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      function pickTab(btn) {
        tabBtns.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.addEventListener('click', function (e) {
        var b = e.target.closest('[role="tab"]');
        if (b) pickTab(b);
      });
      tabs.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var i = tabBtns.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var to = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabBtns.length) % tabBtns.length;
        tabBtns[to].focus();
        pickTab(tabBtns[to]);
      });
    }

    // the photo, large. The drawer handler opens and closes it; this only says which photo, and
    // it looks the overlay up on the document because header.liquid moves every drawer to the body.
    var lb = document.querySelector('[data-lightbox]');
    var lbImg = lb && lb.querySelector('[data-lb-img]');
    if (lb && lbImg && track) {
      var lbAt = 0;
      function lbList() {
        return Array.prototype.filter.call(track.querySelectorAll('.pdp__slide'), function (sl) {
          return !sl.hidden && sl.querySelector('[data-zoom] img');
        });
      }
      function lbShow(i) {
        var list = lbList();
        if (!list.length) return;
        lbAt = (i + list.length) % list.length;
        var slide = list[lbAt], img = slide.querySelector('[data-zoom] img');
        // the src attribute, not currentSrc: that one is cut to the column's 512
        lbImg.src = img.getAttribute('src');
        lbImg.alt = img.alt;
        // only the ratio is wanted here, to hold the frame's shape while the larger file arrives;
        // the slide's own candidate carries it, and the garments and the print cards differ
        if (img.naturalWidth) { lbImg.width = img.naturalWidth; lbImg.height = img.naturalHeight; }
        var art = slide.hasAttribute('data-art');
        lb.classList.toggle('is-art', art);
        lb.classList.toggle('is-white', art && slide.classList.contains('is-white'));
        Array.prototype.forEach.call(lb.querySelectorAll('[data-lb-step]'), function (b) { b.hidden = list.length < 2; });
      }
      root.addEventListener('click', function (e) {
        var z = e.target.closest('[data-zoom]');
        if (z) lbShow(lbList().indexOf(z.closest('.pdp__slide')));
      });
      lb.addEventListener('click', function (e) {
        var step = e.target.closest('[data-lb-step]');
        if (step) lbShow(lbAt + Number(step.getAttribute('data-lb-step')));
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'ArrowRight') lbShow(lbAt + 1);
        else if (e.key === 'ArrowLeft') lbShow(lbAt - 1);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-rec]');
    if (!el || el.children.length) return;
    var load = function () {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-rec]');
        if (fresh && fresh.children.length) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(el);
    } else load();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('search-drawer');
    if (!drawer) return;
    var input = drawer.querySelector('[data-srch-input]');
    var results = drawer.querySelector('[data-srch-results]');
    var clear = drawer.querySelector('[data-srch-clear]');
    var form = drawer.querySelector('[data-srch-form]');
    var url = drawer.getAttribute('data-url');
    var currency = drawer.getAttribute('data-currency') || 'USD';
    var searchUrl = form.getAttribute('action');
    var startHTML = results.innerHTML;
    var timer, ctrl, last = '', lastLimit = 0;

    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function money(v) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(Number(v)); } catch (e) { return v; } }
    function thumb(p) {
      var u = (p.featured_image && p.featured_image.url) || p.image || '';
      return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
    }
    function fullSearch(q) { return searchUrl + '?q=' + encodeURIComponent(q) + '&type=product'; }

    function render(q, data) {
      var r = (data.resources && data.resources.results) || {};
      var prods = r.products || [], cols = r.collections || [], pages = r.pages || [];
      if (!prods.length && !cols.length && !pages.length) {
        results.innerHTML = '<p class="srchd__none">Nothing for “' + esc(q) + '”. Try a garment (“hoodie”), an age (“toddler”) or a design name.</p>' + startHTML;
        return;
      }
      var h = '';
      if (cols.length || pages.length) {
        h += '<ul class="srchd__chips">' +
          cols.map(function (c) { return '<li><a class="chip" href="' + c.url + '">' + esc(c.title) + '</a></li>'; }).join('') +
          pages.map(function (p) { return '<li><a class="chip" href="' + p.url + '">' + esc(p.title) + '</a></li>'; }).join('') +
          '</ul>';
      }
      if (prods.length) {
        h += '<ul class="srchd__grid">' + prods.map(function (p) {
          var bits = p.title.replace(' — ', ' - ').split(' - '), i = thumb(p);
          return '<li><a class="srchd__card" href="' + p.url + '">' +
            (i ? '<img src="' + i + '" alt="" width="400" height="500">' : '<span class="srchd__ph"></span>') +
            '<span class="srchd__name">' + esc(bits[0]) + '</span>' +
            (bits[1] ? '<span class="srchd__meta">' + esc(bits[1]) + '</span>' : '') +
            '<span class="srchd__price">' + money(p.price) + (p.available === false ? ' · Sold out' : '') + '</span></a></li>';
        }).join('') + '</ul>';
        h += '<p class="srchd__all"><a class="link" href="' + fullSearch(q) + '">See all results for “' + esc(q) + '”</a></p>';
      }
      results.innerHTML = h;
    }

    function search(q, limit) {
      q = q.trim();
      clear.hidden = !q;
      if (!q) { results.innerHTML = startHTML; last = ''; return; }
      if (q === last && limit === lastLimit) return;
      last = q; lastLimit = limit;
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      var u = url + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=' + limit + '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      results.classList.add('is-loading');
      fetch(u, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { render(q, d); })
        .catch(function (e) {
          if (e.name === 'AbortError') return;
          results.innerHTML = '<p class="srchd__none">Search isn’t answering right now. <a class="link" href="' + fullSearch(q) + '">Open the search page</a>.</p>';
        })
        .finally(function () { results.classList.remove('is-loading'); });
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { search(input.value, 6); }, 160); });
    // Enter leaves for /search. It used to be caught here and answered with ten results in the panel,
    // which looked the same as the six already there and left the address bar on whatever page you
    // happened to be standing on; the form's own action is the full results page, so let it go.
    form.addEventListener('submit', function () { clearTimeout(timer); });
    clear.addEventListener('click', function () { input.value = ''; search('', 6); input.focus(); });
    results.addEventListener('click', function (e) {
      var t = e.target.closest('[data-srch-try]');
      if (t) { input.value = t.getAttribute('data-srch-try'); search(input.value, 6); input.focus(); }
    });
    // the generic drawer code focuses the first control; we want the field
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open="search-drawer"]')) setTimeout(function () { input.focus(); input.select(); }, 0);
    });
    // "/" opens search from anywhere on the page
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      var a = document.activeElement;
      if (a && (/input|textarea|select/i.test(a.tagName) || a.isContentEditable)) return;
      var opener = document.querySelector('[data-open="search-drawer"]');
      if (opener) { e.preventDefault(); opener.click(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staples-row"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sr]').forEach(function (sec) {
    sec.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sr-dept]');
      if (!btn) return;
      var key = btn.getAttribute('data-sr-dept');
      sec.querySelectorAll('[data-sr-dept]').forEach(function (b) { var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      sec.querySelectorAll('[data-sr-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-sr-panel') !== key; });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
